import lang from "@/views/modules/UserDashlets/language/en";
import Editor from '@tinymce/tinymce-vue';


export default {
    name: "new-product",

    components: {

        'editor': Editor,
    },
    data() {
        return {
            loading: true,
            dom_array: [],
            lang: [],
            userdashlet: {
            },

            selectedModules: [],
            selectedModules2: {},
            process: false,
        }
    },
    mounted() {
        this.lang = lang;
        this.dom_array = this.domArrayVariable;
    },
    methods: {
        saveUserDashlet() {
            const errorMessages = document.getElementsByClassName('error-message');
            while (errorMessages.length > 0) {
                errorMessages[0].remove();
            }
            const self = this;
            if (self.userdashlet.name == '') {
                self.userdashlet.name = self.dom_array.module_dashlet[self.userdashlet.module]
            }

            //  console.log(self.selectedModules);
            self.userdashlet.module =self.selectedModules;
            self.userdashlet.name =self.selectedModules2;

            self.process = true;
            axios.post('api/modules/userdashlets', self.userdashlet).then(function (response) {
                self.process = false;
                self.$router.push('/modules/userdashlets');
            }).catch(function () {
                self.process = false;
                let err = localStorage.getItem('Errors');
                let err_msg = (JSON.parse(err));
                let err_msg2 = err_msg.errors;
                Object.keys(err_msg2).forEach((key) => {
                    let errorval = err_msg2[key];
                    const input = document.getElementById(key);
                    const errorDiv = document.createElement('span');
                    errorDiv.className = 'error-message error';
                    errorDiv.textContent = errorval;
                    input.insertAdjacentHTML('afterend', errorDiv.outerHTML);
                });
                localStorage.removeItem('Errors');
                localStorage.removeItem('Errors');
            });
        },
    }
}